import { BookOpenCheckIcon, FileTextIcon, FolderOpenIcon, ListChecksIcon, MessageCircleQuestionIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  benefit: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Industrial Instrumentation Classroom Activities & Challenges',
    description:
      '150 ready-to-use activity ideas covering measurement principles, instrument performance, sensors and transducers, industrial signals, 4–20 mA scaling, temperature and pressure measurement, level and flow measurement, process control, control loops, control valves, PLC and automation, HMI and SCADA, calibration and maintenance, troubleshooting, and integrated instrumentation situations. Organized by difficulty level and topic.',
    benefit: 'Materials already designed for your classroom: saves hours every quarter.',
    value: 'USD 14',
    icon: FolderOpenIcon,
  },
  {
    number: '02',
    title: 'Industrial Instrumentation Teacher Assessment Kit',
    description:
      'Comprehensive assessment resources designed to evaluate student learning throughout an industrial instrumentation course. Includes:',
    items: [
      'Foundational level assessments',
      'Intermediate level assessments',
      'Advanced level assessments',
      'Short-answer questions',
      'True/false questions with justification',
      'Concept understanding exercises',
      'Application questions',
      'Industrial scenarios',
      'Signal scaling calculations',
      'Measurement error analysis',
      'Control loop evaluation',
      'PLC and automation concepts',
      'Calibration and maintenance reasoning',
      'Safety reasoning',
      'Technical communication',
      'Integrated problems',
      'Teacher guidance',
    ],
    benefit: 'Never build an exam from scratch under pressure again.',
    value: 'USD 14',
    icon: ListChecksIcon,
  },
  {
    number: '03',
    title: '100 Industrial Instrumentation Case Studies & Problem-Solving Scenarios',
    description:
      'A collection of 100 developed industrial instrumentation cases involving measurement problems, instrument performance, sensor and transmitter issues, industrial signal problems, temperature, pressure, level and flow measurement, control loop problems, PLC and automation scenarios, calibration and maintenance challenges, troubleshooting and diagnosis, safety reasoning, and integrated instrumentation situations.',
    benefit: 'Students analyze facts, evaluate evidence, identify problems, and develop technical solutions.',
    value: 'USD 14',
    icon: FileTextIcon,
  },
  {
    number: '04',
    title: 'Industrial Instrumentation Teacher Dictionary: 200 Essential Concepts Explained',
    description:
      'Comprehensive reference handbook covering 200 essential industrial instrumentation concepts designed to help teachers explain vocabulary and concepts clearly. Includes terminology related to:',
    items: [
      'Measurement Fundamentals',
      'Instrument Performance',
      'Sensors & Transducers',
      'Transmitters',
      'Industrial Signals',
      'Temperature Measurement',
      'Pressure Measurement',
      'Level Measurement',
      'Flow Measurement',
      'Process Control',
      'PID Control',
      'Control Valves',
      'PLC & Automation',
      'HMI & SCADA',
      'Industrial Communications',
      'Calibration',
      'Maintenance & Reliability',
      'Troubleshooting',
      'Instrument Safety',
    ],
    benefit: 'Project it in class and your students instantly understand complex instrumentation concepts.',
    value: 'USD 14',
    icon: BookOpenCheckIcon,
  },
  {
    number: '05',
    title: '100 Questions Students Ask About Industrial Instrumentation',
    description:
      'A collection of 100 common student questions designed to help teachers explain difficult industrial instrumentation concepts more clearly. Includes questions covering:',
    items: [
      'Measurement Fundamentals',
      'Accuracy & Precision',
      'Measurement Errors',
      'Sensors & Transducers',
      'Transmitters',
      '4–20 mA Signals',
      'Temperature & Pressure',
      'Level & Flow',
      'Process Control',
      'PV, SP & MV',
      'Control Valves',
      'PLC & Automation',
      'HMI & SCADA',
      'Calibration',
      'Maintenance',
      'Troubleshooting',
      'Safety',
      'Complete Instrumentation Systems',
    ],
    benefit:
      'Each section helps educators address common doubts, clarify misconceptions, and connect technical concepts with industrial examples.',
    value: 'USD 14',
    icon: MessageCircleQuestionIcon,
    wide: true,
  },
];
